import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LogIn, Shield } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  if (loading) return <div className="min-h-screen grid place-items-center text-slate-500">Loading…</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-xl bg-slate-900 grid place-items-center text-white">
            <Shield className="w-5 h-5" />
          </div>
          <div>
            <p className="text-xs font-bold text-slate-500 uppercase tracking-widest">StudyTrip Global</p>
            <h1 className="font-display text-xl font-extrabold text-slate-900">Admin Login</h1>
          </div>
        </div>

        <form onSubmit={submit} className="rounded-3xl bg-white border border-slate-100 shadow-lg p-6 md:p-8 space-y-4" data-testid="admin-login-form">
          <label className="block">
            <span className="text-xs font-bold text-slate-600 uppercase tracking-wider">Email</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email"
              className="mt-1.5 w-full px-3 py-2.5 rounded-xl bg-slate-50 border border-slate-200 focus:border-blue-500 focus:bg-white text-sm outline-none transition-colors" />
          </label>
          <label className="block">
            <span className="text-xs font-bold text-slate-600 uppercase tracking-wider">Password</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password"
              className="mt-1.5 w-full px-3 py-2.5 rounded-xl bg-slate-50 border border-slate-200 focus:border-blue-500 focus:bg-white text-sm outline-none transition-colors" />
          </label>
          <button type="submit" disabled={submitting} data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-slate-900 hover:bg-slate-800 disabled:opacity-60 text-white font-semibold text-sm transition-colors">
            {submitting ? "Signing in…" : <><LogIn className="w-4 h-4" /> Sign in</>}
          </button>
        </form>
      </div>
    </div>
  );
}
